import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  components: {
    Alert: {
      variants: {
        subtle: (props) => {
          if (props.status === "error") {
            return {
              container: { bg: "white", color: "#00005f" },
              icon: { color: "#00005f" },
              title: { color: "#00005f" },
              description: { color: "#00005f" },
            };
          }
          // leave all other statuses (warning, success, info) at Chakra defaults
          return {};
        },
      },
    },
  },
});

export default theme;
